import React from 'react';
import type { AppProps } from 'next/app';
import Router from 'next/router';
import { GlobalStyles } from '@spotify-internal/encore-web';
import { BrowserMetrics, WebVital } from '@spotify-internal/semantic-metrics';
import '@spotify-internal/encore-web/css/fonts.css';
import '@spotify-internal/encore-web/css/encore-text-styles.css';
import '@spotify-internal/encore-web/css/encore-dark-theme.css';
import '@spotify-internal/encore-web/css/encore-light-theme.css';
import '@spotify-internal/encore-web/css/encore-small-devices-layout-theme.css';
import '@spotify-internal/encore-web/css/encore-medium-devices-layout-theme.css';

import { sendMetric, withRouteMetrics } from '../helpers/semanticMetrics';
import { ErrorBoundaryProvider } from '../components/ErrorBoundary';

const CustomApp = ({ Component, pageProps }: AppProps) => {
  return (
    <>
      <GlobalStyles />
      <ErrorBoundaryProvider>
        <Component {...pageProps} />
      </ErrorBoundaryProvider>
    </>
  );
};

export function reportWebVitals(metric: WebVital) {
  sendMetric(
    BrowserMetrics.getWebVitalsMetric(metric, {
      route: Router.router?.route ?? 'unknown',
    }),
  );
}

export default withRouteMetrics(CustomApp);
